import * as React from 'react';

const StarFilled16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.893 1.354C8.625.48 7.4.452 7.09 1.31L5.656 5.3H1.608c-.917 0-1.302 1.17-.564 1.714L4.143 9.3l-1.21 4.487c-.238.885.79 1.561 1.508.992l3.554-2.818 3.474 2.812c.71.575 1.743-.086 1.519-.971L11.85 9.305l3.105-2.29c.738-.545.353-1.715-.564-1.715h-4.287z"
  }
));
StarFilled16.Size = 16;
StarFilled16.Title = "StarFilled";

export { StarFilled16 as default };
